import React from 'react';
import { 
  HelpCircle, 
  Coins, 
  Clock, 
  Percent, 
  FileText, 
  Shield, 
  Zap, 
  TrendingUp,
  BarChart2
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Coins,
      title: 'Выбор вклада',
      description: 'Сравнивайте предложения разных банков по эффективной ставке с учетом капитализации.'
    },
    {
      icon: Clock,
      title: 'Срок вклада',
      description: 'Более длительные вклады обычно имеют повышенные ставки, но снижают доступность средств.'
    },
    {
      icon: Percent,
      title: 'Капитализация',
      description: 'Вклады с капитализацией увеличивают итоговую доходность, особенно на длительных сроках.'
    },
    {
      icon: FileText,
      title: 'Условия договора',
      description: 'Внимательно читайте условия по снятию и пополнению вклада, а также штрафы за досрочное закрытие.'
    },
    {
      icon: Shield,
      title: 'Страхование',
      description: 'Убедитесь, что банк участвует в системе страхования вкладов (до 1,4 млн ₽ на человека в одном банке).'
    },
    {
      icon: Zap,
      title: 'Регулярные взносы',
      description: 'Пополняемые вклады с регулярными взносами позволяют значительно увеличить итоговую сумму.'
    },
    {
      icon: TrendingUp,
      title: 'Сравнение с инфляцией',
      description: 'Выбирайте вклады со ставкой выше уровня инфляции, чтобы сохранить и приумножить капитал.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-green-500" />
        Советы по вкладам
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <BarChart2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-green-700 dark:text-green-300 mb-2">
              Максимальная доходность
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400 mb-3">
              Для максимальной доходности выбирайте вклады с ежемесячной капитализацией и возможностью пополнения.
            </p>
            <button className="w-full py-1.5 text-xs bg-green-500 text-white rounded hover:bg-green-600 transition-colors">
              Подобрать лучший вклад
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;